import styled from 'styled-components';

export const Layout = styled.div`
  font-size: 1.2rem;
  padding: 0.5rem;
`;
